<template>
	<AgItem :rowData="rowData"
			:columnDefs="columnDefs"
			min-height="164px"
			height="dynamic"
	/>
</template>

<script>
import AgItem from "@/components/templates/agGrid/AgItem";
import {asLocalizedDate, asMoneyAmount} from "@/components/templates/agGrid/formatter/valueFormatters";

export default {
	props: {
		rowData: { type: Array }
	},
	components: {
		AgItem,
	},
	data() {
		return {
			columnDefs: [],
		};
	},
	beforeMount() {
		this.setColumnDefs();
	},
	methods: {
		setColumnDefs() {
			this.columnDefs = [
				{
					headerName: this.$t("common.dueDate"),
					field: "dueDate",
					valueFormatter: asLocalizedDate()
				},
				{
					headerName: this.$t("common.amount"),
					headerClass: "align-right",
					field: "amount",
					cellStyle: {'justify-content': 'flex-end'},
					valueFormatter: asMoneyAmount(),
				},
				{
					headerName: this.$t("common.invoiceNumber"),
					field: "invoiceNumber",
					minWidth: 175,
					cellRendererFramework: "FileLink",
					cellRendererParams: {
						fileIdField: "invoiceFileId"
					},
				},
				{
					headerName: this.$t("common.progress"),
					minWidth: 100,
					cellRendererFramework: "RevolvingPutOptionPremiumPaymentsStatusRenderer",
				}
			]
		},
	},
};
</script>